import { render, staticRenderFns } from "./UserCredentialList.vue?vue&type=template&id=2e1788f2"
import script from "./UserCredentialList.vue?vue&type=script&lang=ts"
export * from "./UserCredentialList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports